<template>
  <button
    @click="($event) => $emit('click', $event)"
    class="frisbuy-like-button"
    :class="[{ 'frisbuy-like-button--liked': isLiked }]"
  >
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2727 3.46769C10.2727 2.10489 9.12152 1 7.70125 1C6.76605 1 5.95017 1.48038 5.50002 2.19649C5.04988 1.48062 4.23399 1 3.29879 1C1.87853 1.00024 0.727295 2.10489 0.727295 3.46769C0.727295 3.77911 0.790094 4.07606 0.899867 4.35036C1.75017 6.69729 5.50002 9.27273 5.50002 9.27273C5.50002 9.27273 9.24988 6.69729 10.1004 4.35036C10.2102 4.07606 10.2727 3.77911 10.2727 3.46769Z"
        stroke="#6E6E6E"
        stroke-width="0.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</template>

<style scoped lang="scss">
.frisbuy-like-button {
  display: block;
  aspect-ratio: 1 / 1;

  background-color: #ffffff;
  border: none;
  border-radius: 50%;

  cursor: pointer;

  z-index: 1;

  &.frisbuy-like-button--liked {
    svg {
      fill: #6e6e6e;
    }
  }

  svg {
    position: absolute;

    width: 50%;
    height: auto;

    inset: 50%;
    transform: translate(-50%, -50%);

    fill: #ffffff;
  }
}
</style>

<script>
export default {
  emits: ["click"],

  props: {
    isLiked: {
      type: Boolean,
      required: false,
      default: false,
    },

    productArticle: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>
